var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 146 146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a7c4bf;}.cls-2{fill:none;stroke:#374f49;stroke-miterlimit:10;stroke-width:5px;}.cls-3{fill:gray;}.cls-4{fill:#b9ded8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123,23V123H23V23H123M146,0H0V146H146V0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M123,23V123H23V23H123M143,3H3V143H143V3h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 23,
    y: 23,
    width: 100,
    height: 100
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 134.5,
    cy: 11.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 134.5,
    cy: 135.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.5,
    cy: 11.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.5,
    cy: 135.5,
    r: 4.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressBorder);
export default __webpack_public_path__ + "static/media/progress-border.9e0d01f86e4f4d8c09073db6b89ae350.svg";
export { ForwardRef as ReactComponent };